import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export default function Breadcrumbs({ items = [] }) {
  return (
    <nav className="flex items-center gap-1.5 text-xs text-[#6f6a63] py-4 overflow-x-auto">
      <Link to="/" className="flex items-center gap-1 hover:text-[#2d2d2d] whitespace-nowrap">
        <Home size={12} /> Home
      </Link>
      {items.map((item, i) => (
        <React.Fragment key={i}>
          <ChevronRight size={12} className="flex-shrink-0" />
          {item.href ? (
            <Link to={item.href} className="hover:text-[#2d2d2d] whitespace-nowrap">{item.label}</Link>
          ) : (
            <span className="text-[#2d2d2d] font-medium whitespace-nowrap">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
